module.exports = __webpack_public_path__ + "img/ubicacion--white.3f864192.svg";